module.exports = __webpack_public_path__ + "img/left-logo.c8290786.png";